export const HelmetTitle = ({ pageTitle }: { pageTitle: string }) => {
  const title = pageTitle ? `VIPER | ${pageTitle}` : "VIPER";

  return <title>{title}</title>;
};
